import { render, staticRenderFns } from "./category-goods.vue?vue&type=template&id=fabec7ee&scoped=true&"
import script from "./category-goods.vue?vue&type=script&lang=js&"
export * from "./category-goods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabec7ee",
  null
  
)

export default component.exports